import { render, staticRenderFns } from "./Premiums.vue?vue&type=template&id=3369c91a&scoped=true"
import script from "./Premiums.vue?vue&type=script&lang=js"
export * from "./Premiums.vue?vue&type=script&lang=js"
import style0 from "./Premiums.vue?vue&type=style&index=0&id=3369c91a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3369c91a",
  null
  
)

export default component.exports